/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useStatiegeldStats } from "../../store/useStatiegeldStats";
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { StatiegeldSupergroupTable } from "./StatiegeldSupergroupTable";
import { StatiegeldBarcodeTable } from "./StatiegeldBarcodeTable";
import { useStatiegeldProducts } from "../../store/useStatiegeldProducts";
import {
  HorizontalData,
  StatiegeldDropsCount,
  StatiegeldDropsLocationCount,
} from "../../components";

function StatiegeldStatsScreen() {
  /** Hooks */
  const { statiegeldStats, getStatiegeldStats } = useStatiegeldStats();
  const { getStatiegeldProducts } = useStatiegeldProducts();

  useEffect(() => {
    getStatiegeldStats();
    getStatiegeldProducts(1, 1000);
  }, []);

  return (
    <div>
      {/* Top Stats */}
      <HorizontalData
        data={[
          {
            label: "Registered Statiegeld bags",
            value: statiegeldStats?.totalStatiegeldDrops ?? 0,
          },
          {
            label: "Total refund",
            value: `${Number(
              (statiegeldStats?.totalRefundAmount ?? 0) / 100
            )?.toFixed(2)} €`,
          },
          {
            label: "Total items count",
            value: `${statiegeldStats?.totalItemsCount} units`,
          },
        ]}
      />
      <StatiegeldDropsCount />
      <StatiegeldDropsLocationCount />
      {/* Products based on SuperGroup */}
      <p className="font-satoshi font-bold text-lg mb-2 pl-3">
        List of products based on Can type
      </p>
      <div className="w-full px-7 py-7 bg-white rounded-xl border-gray-border drop-shadow-none mb-6">
        {!statiegeldStats?.supergroupStats?.length ? (
          <p className="text-center font-satoshi text-base text-dark">
            There is no Statiegeld drop created yet.
          </p>
        ) : (
          <StatiegeldSupergroupTable />
        )}
      </div>
      {/* Products based on Barcode */}
      <p className="font-satoshi font-bold text-lg mb-2 pl-3">
        List of products based on GTIN
      </p>
      <div className="w-full px-7 py-7 bg-white rounded-xl border-gray-border drop-shadow-none">
        {!statiegeldStats?.gtinStats?.length ? (
          <p className="text-center font-satoshi text-base text-dark">
            There is no Statiegeld drop created yet.
          </p>
        ) : (
          <StatiegeldBarcodeTable />
        )}
      </div>
    </div>
  );
}

export default withProtectedRoute(StatiegeldStatsScreen);
